import { render, staticRenderFns } from "./LiveEditorDialog.vue?vue&type=template&id=c8cd91ec&scoped=true"
import script from "./LiveEditorDialog.vue?vue&type=script&lang=js"
export * from "./LiveEditorDialog.vue?vue&type=script&lang=js"
import style0 from "./LiveEditorDialog.vue?vue&type=style&index=0&id=c8cd91ec&prod&lang=scss&scoped=true"
import style1 from "./LiveEditorDialog.vue?vue&type=style&index=1&id=c8cd91ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cd91ec",
  null
  
)

export default component.exports